<template>
	<div class="brackets__generating-loader">
		<h5>{{$t('Starting tournament. Hold on for a while.')}}</h5>
		<span class="loader"></span>
	</div>
</template>

<script>
	export default {
		name: "BracketsGeneratingLoader",
	};
</script>